function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0H375V100H0z",
  transform: "translate(-321 -38)"
}), React.createElement("g", {
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, React.createElement("path", {
  d: "M4.5 6.278L19.13 6.278M4.5 11.889L19.13 11.889M4.5 17.889L13.5 17.889",
  transform: "translate(-321 -38) matrix(-1 0 0 1 355 38)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "10 2 24 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/gnb.2934b08b.svg";
export { SvgComponent as ReactComponent };